(function () {
    'use strict';

    angular
        .module('franchisee-portal', [
            'ngSanitize',
            'ui.router',
            'ui.select',
            'smart-table',
            '19degrees.ngSweetAlert2',
            'angularValidator',
            'ngMask',
            'ngNotify',
            'flow',
            'ngQuill',
            'ngTagsInput',
            'ui.bootstrap.materialPicker',
            'daterangepicker',
            'ui.bootstrap.contextMenu',
            'ui.swiper',
            'infinite-scroll',
            'textAngular',

            'franchisee-portal.configs',
            'franchisee-portal.constants',
            'franchisee-portal.components',
            'franchisee-portal.directives',
            'franchisee-portal.filters',
            'franchisee-portal.interceptors',
            'franchisee-portal.routes',
            'franchisee-portal.services',
        ])
        .run(run);

    /** @ngInject */
    function run($trace, $transitions, $rootScope, $window, $location, HelperService) {
        $trace.enable(1, 5);

        // if ($location.path() == '/') {
        //     $location.path('/news/internal/82');
        // }

        HelperService.handleOnRun();

        $rootScope.$on('$locationChangeStart', event => {
            HelperService.handleLocationChangeStart(event);
        });

        $transitions.onEnter({}, $transition => {
            return HelperService.handleStateChangeStart($transition);
        });

        $transitions.onSuccess({}, $transition => {
            $rootScope.pageTitle = `${$transition.to().title} - Portal do Franqueado 5àsec`;

            HelperService.handleStateChangeSuccess();
        });

        $transitions.onError({}, ($transition, error) => {
            console.log('$transition: ', $transition);
            console.log('error: ', error);
            HelperService.handleStateChangeError(error);
        });

        $window.onload = () => {
            HelperService.handleViewContentLoaded();
        }

        angular.element($window).on('resize', () => $rootScope.isMobile = HelperService.isScreenSmaller(991));

        $rootScope.$on('$viewContentLoaded', HelperService.handleViewContentLoaded);
    }
})();